"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
const Icon_1 = __importDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
const Checkbox_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
const Pill_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
const TextField_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
const styles = __importStar(require("./MultiSelectComboBoxFilter.css"));
const CustomComponent_1 = __importDefault(require("../custom-component/CustomComponent"));
const react_1 = require("react");
const constants_1 = require("../../constants");
const Utils_1 = require("./Utils");
const MultiSelectComboBoxFilter = (props) => {
    const { selectedIndex, expanded, searchTerm, disabled, selectedOptions, applyOn, id, options, values, filterLabel, disabledFilterLabel, filterLabelMode, } = props;
    const searchRef = (0, react_1.createRef)();
    const btnRef = (0, react_1.createRef)();
    const keyRef = (0, react_1.createRef)();
    const ulRef = (0, react_1.createRef)();
    const componentClassName = `${constants_1.ANG_CSS_PREFIX}-filter-multiselect`;
    const buttonActiveClass = (0, Utils_1.getActiveButtonCssClass)(values, componentClassName);
    const arrowOpenClass = (0, Utils_1.getArrowOpenCssClass)(expanded);
    const groups = options.map(o => o.group).filter((value, index, all) => all.indexOf(value) === index);
    const refs = {};
    const selected = selectedIndex > -1 && options.length > 0 ? options[selectedIndex].key : '';
    options.forEach(o => (refs[o.key] = (0, react_1.createRef)()));
    (0, react_1.useEffect)(() => {
        if (selected !== '' && ulRef && ulRef.current) {
            // @ts-ignore
            ulRef.current.scrollTo(0, refs[selected].current.offsetTop);
        }
    }, [selected, ulRef, refs]);
    function handleToggle() {
        (0, Utils_1.handleToggleUtil)(props, keyRef);
    }
    function Blur(e) {
        if (applyOn === 'blur' && !e.currentTarget.contains(e.relatedTarget)) {
            props.handleExpandChange(false);
            props.handleApply();
        }
    }
    function KeyUp(e) {
        (0, Utils_1.KeyUpUtil)(e, props, handleToggle);
    }
    function ChangeSearch(e) {
        props.handleSelected(-1);
        props.handleSearchTerm(e.value);
    }
    function EnterSearch() {
        props.handleSearchEnter();
    }
    function KeyDown(e) {
        (0, Utils_1.KeyDownUtil)(e, props, handleToggle);
    }
    function handleLabelClick(e) {
        const key = e.target.dataset.key;
        const option = options.find(o => o.key === key);
        if (option && !option.disabled) {
            // @ts-ignore
            props.handleCheckBoxChange(key, !option.checked);
        }
    }
    const renderOptions = (optionList, groupIndex) => {
        return optionList.map((option, optionIndex) => (React.createElement("li", { className: `${styles.li} ${componentClassName}-dropdown-ul-li ${selected === option.key ? styles.active || componentClassName + '-dropdown-ul-active' : ''}
        ${option.disabled ? 'disabled' : ''}`, key: `li-${option.key}`, ref: refs[option.key], "data-test-id": `${id}-ul-li`, "aria-disabled": option.disabled, "data-disabled": option.disabled, role: 'option', "aria-selected": selected === option.key, "aria-labelledby": `${id}-option-${groupIndex}-${optionIndex}-label`, id: `${option.key}` },
            React.createElement(Checkbox_1.default, { tabindex: -1, key: 'chk-' + option.key, checked: option.checked, onChange: (e) => {
                    props.handleCheckBoxChange(option.key, e.value);
                }, disabled: option.disabled }),
            React.createElement("span", { key: 'chk-label-' + option.key, title: option.label, className: `${styles.label} ${componentClassName}-dropdown-ul-li-label`, onClick: handleLabelClick, "data-key": option.key, id: `${id}-option-${groupIndex}-${optionIndex}-label` }, option.label),
            option.customID && props.customComponents && props.customComponents[option.customID] && (React.createElement(CustomComponent_1.default, { "data-test-id": `custom-component-${option.customID}`, id: option.customID, custom: props.customComponents[option.customID] })))));
    };
    const pills = selectedOptions.map(option => (React.createElement(Pill_1.default, { className: `${styles.multiSelectBtnLabelPill} ${componentClassName}-button-content-label-pill`, key: `${id}-${option.key}-pill`, testId: 'multiselect-pills-label', onRemove: () => props.handlePillRemoval(option.key), disabled: disabled || option.disabled }, option.label)));
    const renderLabel = () => {
        if (disabled && disabledFilterLabel !== '') {
            return disabledFilterLabel;
        }
        if (filterLabelMode === 'pills' && selectedOptions.length > 0) {
            return pills;
        }
        return filterLabel;
    };
    return (React.createElement("div", { className: `${styles.multiSelectFilter} ${componentClassName} ${disabled ? 'disabled' : ''}`, "data-test-id": 'multi', tabIndex: -1, onBlur: Blur, id: id },
        React.createElement(Button_1.default, { "data-test-id": `${id}-toggle-button`, testId: `${id}-toggle-button-testId`, className: `${styles.multiSelectBtn} ${componentClassName}-button ${buttonActiveClass}`, kind: "tertiary", noFill: true, onClick: handleToggle },
            React.createElement("div", { className: `${styles.multiSelectBtnContent} ${componentClassName}-button-content`, ref: keyRef, tabIndex: expanded ? 0 : -1, onKeyDown: KeyDown, onKeyUp: KeyUp, "data-test-id": `${id}-toggle-button-div`, role: "combobox", "aria-label": id, "aria-expanded": expanded, "aria-controls": `${id}-expanded-list`, "aria-activedescendant": selected },
                React.createElement("span", { className: `${styles.multiSelectBtnLabel} ${componentClassName}-button-content-label`, "data-test-id": `${id}-toggle-button-div-span` }, renderLabel()),
                React.createElement(Icon_1.default, { name: 'arrow-down-small', size: "xs", className: `${styles.arrowIcon} ${componentClassName}-button-content-arrow ${arrowOpenClass}`, "data-test-id": `${id}-toggle-button-div-icon` }))),
        expanded &&
            React.createElement("div", { className: `${styles.dropdown} ${componentClassName}-dropdown`, "data-test-id": 'multi-expanded', id: `${id}-expanded-list` },
                props.searchable && (React.createElement("div", { "data-test-id": `${id}-search-box`, className: `${styles.dropdownHeader} ${componentClassName}-dropdown-header`, ref: searchRef },
                    React.createElement(TextField_1.default, { type: "search", placeholder: "Search", size: 'md', onChange: ChangeSearch, onEnter: EnterSearch, value: searchTerm, testId: `${id}-search-box-text-field` }))),
                React.createElement("ul", { className: `${styles.ul} ${componentClassName}-dropdown-ul`, id: `${id}-ul`, ref: ulRef, tabIndex: -1, "data-test-id": `${id}-ul`, role: 'listbox' }, groups.map((group, ig) => {
                    if (group !== '') {
                        return (React.createElement("li", { key: group + '_li', "data-test-id": `${id}-ul-group-li` },
                            React.createElement("span", { key: group + '_span', className: `${styles.groupTitle} ${componentClassName}-dropdown-group-title` }, group),
                            React.createElement("ul", { key: group + '_ul', "data-test-id": `${id}-ul-group-li-ul` }, renderOptions(options.filter(o => o.group === group), ig))));
                    }
                    else {
                        return renderOptions(options.filter(o => o.group === group), ig);
                    }
                })),
                React.createElement("div", { className: `${styles.dropdownFooter} ${componentClassName}-dropdown-footer`, ref: btnRef, id: `${id}-buttons`, "data-test-id": `${id}-buttons` },
                    React.createElement(Button_1.default, { className: `${styles.btnClear}  ${componentClassName}-dropdown-footer-button-clear`, kind: "tertiary", onClick: props.handleClear, disabled: options.filter(v => v.checked && !v.disabled).length === 0, "data-test-id": `${id}-buttons-clear` },
                        React.createElement("span", null, "Clear filter")),
                    React.createElement(Button_1.default, { kind: "secondary", onClick: props.handleApply, "data-test-id": `${id}-buttons-apply` },
                        React.createElement("span", null, "Apply"))))));
};
exports.default = MultiSelectComboBoxFilter;
